import React, { Component } from 'react'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import styles from './itens.module.css'
import AbaItens from './AbaItens'
import { getAuthentication, saveSecurityToken } from '../../security/securityContext'
import { atualizarFiltros } from '../../actions/filtrosActions'
import {
  descartarFotoPessoaRecuperada,
  recuperarFoto
} from '../../actions/contextoAplicacaoActions'
import { recuperarVisao, determinarVisaoAtualizada } from '../../actions/itensPorVisaoActions'
import { temUnidadesAtuaisSelecionadas } from '../../controllers/unidadesController'
import ScrollToTop from '../util/ScrollToTop'
import App from '../App'
import {
  sistemas,
  PORTAL_ORIGIN_ACCESS,
  visualizarUrlSistemaLinksExternos,
  recuperarTipoVinculoUsuarioUnidade
} from '../../controllers/itensController'

export class PainelPrincipal extends Component {
  componentDidMount() {
    const {
      filtros,
      filtros: { unidadesAtuais },
      unidadesUsuario: { codigoUsuario }
    } = this.props
    if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
      this.props.recuperarVisao(filtros, () => this.props.recuperarFoto(codigoUsuario))
    }
    this.openEtcuWhenOriginFromPortal()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      filtros,
      itens: { visaoAtualizada }
    } = this.props
    const { filtros: prevFiltrosProcessos } = prevProps
    if (filtros !== prevFiltrosProcessos || visaoAtualizada === false) {
      const slowRequest = visaoAtualizada !== false
      const { unidadesAtuais } = filtros
      if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
        this.props.recuperarVisao(filtros, this.props.recuperarFoto, slowRequest)
      }
      this.props.determinarVisaoAtualizada()
    }
  }

  componentWillUnmount() {
    this.props.descartarFotoPessoaRecuperada()
  }

  openEtcuWhenOriginFromPortal() {
    const {
      authentication: { username, origin }
    } = this.props
    if (origin === PORTAL_ORIGIN_ACCESS) {
      const callback = (tipoVinculoUsuarioUnidade) => {
        const authentication = { ...getAuthentication(), origin: undefined }
        saveSecurityToken(authentication)
        if (tipoVinculoUsuarioUnidade.first === 'UNIDADE_GABINETE_MINISTRO')
          return visualizarUrlSistemaLinksExternos(sistemas.etcuGabinetes.id, () =>
            window.open(tipoVinculoUsuarioUnidade.second, '_self')
          )
        if (tipoVinculoUsuarioUnidade.first === 'UNIDADE_RESTRITA_ETCU_LEGADO')
          return visualizarUrlSistemaLinksExternos(sistemas.etcu.id, (url) =>
            window.open(url, '_self')
          )
        return null
      }
      recuperarTipoVinculoUsuarioUnidade(username, callback)
    }
  }

  renderContent() {
    const {
      filtros: { unidadesAtuais },
      itens: { visao }
    } = this.props
    if (!temUnidadesAtuaisSelecionadas(unidadesAtuais) || !visao) {
      return null
    } else {
      return <AbaItens />
    }
  }

  render() {
    const {
      filtros: { todasUnidadesDesmarcadas },
      unidadesUsuario: { usuarioSemVisaoUnidade }
    } = this.props
    return (
      <App>
        <Grid container spacing={2} justifyContent='center' className={styles.root}>
          <ScrollToTop />
          <Grid item xs={12}>
            {this.renderContent()}
          </Grid>
          {usuarioSemVisaoUnidade ? (
            <Grid item xs={12}>
              <Typography
                variant='h6'
                color='error'
                paragraph
                style={{ marginTop: 24, marginLeft: 16 }}>
                {`Usuário "${getAuthentication().username}" sem visão em nenhuma unidade SEGECEX.`}
              </Typography>
            </Grid>
          ) : null}
          {todasUnidadesDesmarcadas ? (
            <Grid item xs={12}>
              <Typography
                variant='h6'
                color='error'
                paragraph
                style={{ marginTop: 24, marginLeft: 16 }}>
                Selecione "UNIDADES TÉCNICAS" para visualizar seus processos...
              </Typography>
            </Grid>
          ) : null}
        </Grid>
      </App>
    )
  }
}

const mapStateToProps = ({ filtros, itens, unidadesUsuario, authentication }) => ({
  filtros,
  itens,
  unidadesUsuario,
  authentication
})

export default connect(mapStateToProps, {
  recuperarFoto,
  recuperarVisao,
  atualizarFiltros,
  determinarVisaoAtualizada,
  descartarFotoPessoaRecuperada
})(PainelPrincipal)
